import styled from "styled-components";

export const StyledLogo = styled.img`
max-width: 100%;
width: 310px;
height: 91px;
mix-blend-mode: screen;
padding-bottom: 20px;
`